import { getFileIcon } from './file-type.enum';

export interface Attachment {
  id: number;
  associateModuleId: number;
  associationModule: string;
  associationType: string;
  name: string;
  path: string;
  createdDate: string;
  lastModifiedDate: string;
  createdByName: string;
  createdById: string;
  lastModifiedByName: string;
  lastModifiedById: string;
  candidateId?: number;
}

export class AttachmentAdapter implements Attachment {
  id: number;
  associateModuleId: number;
  associationModule: string;
  associationType: string;
  name: string;
  path: string;
  createdDate: string;
  lastModifiedDate: string;
  createdByName: string;
  createdById: string;
  lastModifiedByName: string;
  lastModifiedById: string;

  constructor(source?: Partial<Attachment>) {
    Object.assign(this, source);
  }

  get extension(): string {
    return this.name.split('.').pop();
  }

  get extensionIcon(): string {
    return getFileIcon(this.extension);
  }
}
